import { create } from 'zustand';

import { clearServiceId, setServiceId } from '@/api/tokens.helper';
import { useAuth } from '@/store/auth/auth.store';

export type ServiceType = 'vessel' | 'service-provider';

type ActiveAccountState = {
  serviceId?: string;
  serviceType?: ServiceType;
  switching: boolean;
  setActiveAccount: (serviceId: string, serviceType: ServiceType) => void;
  clearActiveAccount: () => void;
};

export const useActiveAccount = create<ActiveAccountState>((set) => ({
  switching: false,
  setActiveAccount: (serviceId, serviceType) => {
    set({ serviceId, serviceType });
    setServiceId(serviceId);
    void useAuth.getState().updateRoleForVessel(serviceId);
  },
  clearActiveAccount: () => {
    set({ serviceId: undefined, serviceType: undefined });
    clearServiceId();
  },
}));
